// 页面ID, 用于动态添加路由,如无权限要求,请配置父级权限id
export default {
    home: '',
    incomeOverview: '15',
    incomeList: '14',
    login: '',
    open: '7',
    openCard: '8',
    orderDetail: '190',
    profitOrderDetail: '42',
    orderEdit: '7',
    orderList: '13',
    checkCarExam: '134',
    carExamEdit: '136',
    storeCardEdit: '8',
    client: '11',
    cars: '12',
    carsDetail: '26',
    carsHistory: '138',
    carsHistoryDetails: '138',
    carsInspectionTemplateEdit: '140',
    prePaid: '9',
    prePaidEdit: '9',
    clientPromot: '10',
    prePaidRecord: '22',
    clientDetail: '25',
    pageNotFound: '',
    operators: '16',
    staffEdit: '33',
    staffList: '17',
    roleList: 'role', // 门店主权限
    roleEdit: 'role', // 门店主权限
    notice: '',
    noticeDetail: '',
    logList: '18',
    predict: '60',
    prePaidCrt: '22',
    printOrder: '',
    printStoreDetail: '',
    historyList: '',
    // workerOrderList: '72',
    // workerOrderDetail: '74',
    selfGoods: '79',
    selfGoodsEdit: '79', // 81,82
    enterStoreDetail: '93',
    outStoreDetail: '96',
    agencyGoods: '86', // 代理商品列表
    enterStore: '93', // 入库管理列表
    outStore: '96',
    addAgencyGoods: '88',
    serverReserve: '105', // 服务预约分析
    dataOverview: '100', // 数据概览
    analyseGoods: '101', // 商品分析
    analyseRepairCard: '102', // 爱车卡分析
    analyseSalesActivity: '103', // 营销活动分析
    analyseStoreCard: '104', // 储值卡分析
    analyseCustomer: '106', // 客户分析
    carsInspectionTemplate: '139', // 浏览车检模板139
    carsExamReport:'133', // 车检报告133
    addCarExam: '135',
    serviceList: '152', // 门店服务列表
    serviceEdit: '152', // 新增/编辑门店服务153,154
    writeoffList: '163', // 核销记录
    writeoffDetail: '164', // 核销记录详情
    maintenancePlan: '55', // 保养方案
    maintenanceRecord: '166', // 保养营销记录
    maintenanceRecordDetails: '167', // 保养营销记录详情
    couponList: '168', // 优惠券(可浏览)
    seeCoupon: '168', // 查看优惠券（产品是算在优惠券（可浏览）权限里）
    editCoupon: '170', // 新增编辑优惠券
    couponLaunch: '171', // 发放优惠券
    couponOwner: '172', // 领券车主
    analyseCoupon: '179', // 优惠券分析
    vipExplain: '', // VIP续费升级
    orderSetting: '183', // 订单设置
    carHistoryOrderDetail: '138',
};



// WEBPACK FOOTER //
// ./src/router/pageConfig.js